export const createStyles = (theme?: any, isDark?: boolean) => ({
  selectField: {
    mt: 0,
    cursor: 'pointer',
    '& .MuiOutlinedInput-root': {
      bgcolor: 'background.paper',
      cursor: 'pointer',
    },
    '& .MuiOutlinedInput-input': {
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },
  menuPaper: {
    backgroundColor: isDark ? '#363636' : undefined,
    color: isDark ? '#ffffff' : undefined,
  },
  menu: {
    '& .MuiPaper-root': {
      backgroundColor: isDark ? '#363636 !important' : undefined,
      color: isDark ? '#ffffff' : undefined,
      marginTop: '-1.5rem',
      width: {
        xs: 'calc(343px - 2rem)',
        sm: 'calc(90% - 2rem)',
        md: 'calc(560px - 2rem)',
      },
      maxWidth: {
        xs: 'calc(343px - 2rem)',
        sm: 'calc(90% - 2rem)',
        md: 'calc(560px - 2rem)',
      },
      maxHeight: '300px',
    },
    '& .MuiMenu-paper': {
      backgroundColor: isDark ? '#363636 !important' : undefined,
    },
    '& .MuiPopover-paper': {
      backgroundColor: isDark ? '#363636 !important' : undefined,
    },
    '& .MuiMenu-list': {
      backgroundColor: isDark ? '#363636 !important' : undefined,
    },
    '& .MuiList-root': {
      backgroundColor: isDark ? '#363636 !important' : undefined,
    },
    '& .MuiListItemText-primary': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  optionLabelSx: {
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    minWidth: 0,
  },
});
